import React from "react";
import { X, Plus, Save } from "lucide-react";
import Mo3tiButton from "../../layout/Mo3tiButton";
import ReusableDropdown from "../../../../../components/ReusableDropdown";

const AddDeductionForm = ({
  t,
  theme,
  formStyles,
  showAddForm,
  setShowAddForm,
  newDeduction,
  setNewDeduction,
  lateCalcLoading,
  fetchLateDeduction,
  handleLateHoursChange,
  handleAddDeduction,
  loading,
  language,
  editingDeductionId,
}) => {
  const isEditing = !!editingDeductionId;
  return (
    <>
      {/* Add Deduction Form */}
      <div style={formStyles.section}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: 0,
              color: theme === "dark" ? "#ffffff" : "#1a1a1a",
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            {isEditing ? t("editDeduction") || "Edit Deduction" : t("addDeduction")}
          </h3>
          <Mo3tiButton
            variant="secondary"
            icon={showAddForm ? X : Plus}
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm ? t("cancel") : (isEditing ? t("editDeduction") || "Edit Deduction" : t("addDeduction"))}
          </Mo3tiButton>
        </div>

        {showAddForm && (
          <div>
            <div style={formStyles.formGrid}>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>{t("deductionType")}</label>
                <ReusableDropdown
                  items={[
                    { id: "absence", label: t("absence") },
                    { id: "penalty", label: t("penalty") },
                    { id: "advance", label: t("advance") },
                    { id: "insurance", label: t("insurance") },
                    { id: "sick_leave_25", label: t("sickLeave") },
                    { id: "late_arrival", label: t("lateArrival") },
                    { id: "other", label: t("other") },
                  ]}
                  value={newDeduction.type || ""}
                  onChange={(val) => {
                    if (val) {
                      setNewDeduction({
                        ...newDeduction,
                        type: val,
                      });
                      if (val === "late_arrival") {
                        fetchLateDeduction();
                      }
                    }
                  }}
                  onSelect={(item) => {
                    setNewDeduction({ ...newDeduction, type: item.id });
                    if (item.id === "late_arrival") {
                      fetchLateDeduction();
                    }
                  }}
                  placeholder={t("selectType")}
                  theme={theme}
                  language={language}
                  maxItems={7}
                  getItemKey={(item) => item.id}
                  getItemLabel={(item) => item.label}
                  showAllOnArrowClick={true}
                  showClear={true}
                  onClear={() =>
                    setNewDeduction({
                      ...newDeduction,
                      type: "",
                      amount: "",
                      description: "",
                    })
                  }
                  inputStyle={formStyles.input}
                />
              </div>

              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>{t("amount")}</label>
                {lateCalcLoading && newDeduction.type === "late_arrival" ? (
                  <div
                    style={{
                      ...formStyles.input,
                      display: "flex",
                      alignItems: "center",
                      color: theme === "dark" ? "#aaa" : "#888",
                    }}
                  >
                    {t("calculatingLate")}
                  </div>
                ) : (
                  <input
                    type="number"
                    style={{
                      ...formStyles.input,
                      ...(newDeduction.type === "late_arrival"
                        ? {
                            backgroundColor: theme === "dark" ? "#333" : "#f0f0f0",
                            cursor: "not-allowed",
                          }
                        : {}),
                    }}
                    value={newDeduction.amount}
                    onChange={(e) => {
                      if (newDeduction.type !== "late_arrival") {
                        setNewDeduction({
                          ...newDeduction,
                          amount: e.target.value,
                        });
                      }
                    }}
                    readOnly={newDeduction.type === "late_arrival"}
                    placeholder="0.00"
                  />
                )}
              </div>

              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>
                  {newDeduction.type === "late_arrival"
                    ? t("lateHours")
                    : t("days")}
                </label>
                <input
                  type="number"
                  style={formStyles.input}
                  value={newDeduction.days}
                  onChange={(e) => {
                    if (newDeduction.type === "late_arrival") {
                      handleLateHoursChange(e.target.value);
                    } else {
                      setNewDeduction({
                        ...newDeduction,
                        days: e.target.value,
                      });
                    }
                  }}
                  placeholder={newDeduction.type === "late_arrival" ? "0" : "0"}
                  step={newDeduction.type === "late_arrival" ? "0.5" : "1"}
                />
              </div>
            </div>

            <div style={formStyles.formGroup}>
              <label style={formStyles.label}>{t("description")}</label>
              <textarea
                style={{
                  ...formStyles.input,
                  minHeight: "80px",
                  resize: "vertical",
                }}
                value={newDeduction.description}
                onChange={(e) =>
                  setNewDeduction({
                    ...newDeduction,
                    description: e.target.value,
                  })
                }
                placeholder={t("descriptionPlaceholder")}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <Mo3tiButton
                variant="secondary"
                icon={Save}
                onClick={handleAddDeduction}
                disabled={loading}
              >
                {loading ? t("saving") : (isEditing ? t("update") || "Update" : t("saveDeduction"))}
              </Mo3tiButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AddDeductionForm;